import { render, staticRenderFns } from "./PresentationSideBar.vue?vue&type=template&id=36008ba6"
import script from "./PresentationSideBar.vue?vue&type=script&lang=js"
export * from "./PresentationSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports